import React from "react";

export const MainPage = React.lazy(() => import("../Component/Mainpage"));
export const HomePage = React.lazy(() =>
  import("../Pages/Homepage")
);
export const PRIVACY_POLICY = React.lazy(() =>
  import("../Pages/PrivacyPolicy")
);
export const TERMS_CONDITION = React.lazy(() =>
  import("../Pages/TermsCondition")
);
export const REFUND_POLICY = React.lazy(() =>
  import("../Pages/RefundPolicy")
);
export const DISCLAIMER_Cashtap = React.lazy(() =>
  import("../Pages/DisclaimerEzecred")
);
export const SUPPORT = React.lazy(() =>
  import("../Pages/Support")
);
export const MARKET_SIZE = React.lazy(() =>
  import("../Pages/MarketSize")
);
export const CONTACT_US = React.lazy(() =>
  import("../Pages/ContactUs")
);
